<div *ngIf="(this.mls.featureOnOffList.moduleList.POST.value || !mls.userLoginFlow)">
    <div class="container-shadow bg-white">
        <app-custom-tooltip 
            *ngIf="tooltip_data?.length>0" 
            [tooltip_data]="tooltip_data" 
            [view_identifier]="'POST_BUTTON'" 
            [position]="'top'">
        </app-custom-tooltip>
      <div class="createpost-textbox p-3">
          <div class="row">
              <div class="col-2 pr-0 profile">
                  <div class="box-size-56 mr-2 mt-2">
                      <div class="position-relative">
                        <app-user-pofile-pic 
                            [profile_pic_image]="posting_card_image" 
                            [screenName]='screenName'>
                        </app-user-pofile-pic>
                      </div>
                  </div>
              </div>
              <div class="col-12 pl-0 pr-1 cursor-pointer createpost-cta-container">
                <button type="button" 
                    [disabled]="isPostButtonDisable" 
                    class="createpost-label float-left text-left tooltip-list" 
                    (click)="openFeedPostModal()">
                    <p class="mb-1 secondary-paragraph">{{dataObj?.heading_text}}</p>
                    <p class="secondary-paragraph-bold"><span class="color-grey-400">{{dataObj?.description_text}}</span></p>
                    <span 
                        *ngIf="isPostButtonDisable"
                        class="tooltiptext">{{mls.languageText.post_process.key6}}
                    </span>
                </button>
            </div>
          </div>
      </div>
    </div>
    </div>